import {
  generalAdabyronBehaviour,
  USER_TYPES,
} from '@bit/gerenciatd.utils.ada-byron';
import { MethodType, Context } from '@bit/gerenciatd.utils.types';

export enum PATHS {
  GET_CATALOG_SECTIONS = 'catalogo/secciones',
  GET_CATALOG_SUBSECTION = 'catalogo/subseccion',
  GET_PRODUCT_OFFERING = 'catalogo/oferta',
  GET_PRODUCT_OFFERING_ATTACHMENTS = 'catalogo/documentos',
}

export const getCatalogSections = (
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.GET_CATALOG_SECTIONS,
    userTypes: [USER_TYPES.CLIENT, USER_TYPES.TGES],
    eventName: 'CATALOG.GET_CATALOG_SECTIONS',
    mockedInfo: 'getCatalogSections',
    methodType: MethodType.GET,
  });
};

export const getCatalogSubsection = (
  data: { sectionId: string },
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const { sectionId } = data;
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.GET_CATALOG_SUBSECTION,
    userTypes: [USER_TYPES.CLIENT, USER_TYPES.TGES],
    eventName: 'CATALOG.GET_CATALOG_SUBSECTION',
    queryParams: [{ param: 'id', value: sectionId }],
    mockedInfo: 'getCatalogSubsection',
    methodType: MethodType.GET,
  });
};

export const getProductOffering = (
  data: { idPO: string },
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const { idPO } = data;
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.GET_PRODUCT_OFFERING,
    userTypes: [USER_TYPES.CLIENT, USER_TYPES.TGES],
    eventName: 'CATALOG.GET_PRODUCT_OFFERING',
    queryParams: [{ param: 'id', value: idPO }],
    mockedInfo: 'getProductOffering',
    methodType: MethodType.GET,
  });
};

export const getProductOfferingAttachments = (
  data: { idPO: string },
  context: Context,
  idFront = 'VT',
): Promise<unknown> => {
  const { idPO } = data;
  return generalAdabyronBehaviour({
    context,
    idFront,
    path: PATHS.GET_PRODUCT_OFFERING_ATTACHMENTS,
    userTypes: [USER_TYPES.CLIENT, USER_TYPES.TGES],
    eventName: 'CATALOG.GET_PRODUCT_OFFERING_ATTACHMENTS',
    queryParams: [{ param: 'productOffering', value: idPO }],
    mockedInfo: 'getProductOfferingAttachments',
    methodType: MethodType.GET,
  });
};
